module.exports = __webpack_public_path__ + "img/aeroland-feature-icon-image-mod.8397f042.png";